import React from "react";
import ImageIcon from "@mui/icons-material/Image";
import DescriptionIcon from "@mui/icons-material/Description";
import CodeIcon from "@mui/icons-material/Code";
import VideoFileIcon from "@mui/icons-material/VideoFile";
import AudioFileIcon from "@mui/icons-material/AudioFile";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { getFileCategory } from "./filesUtils";

const CATEGORY_CONFIG = {
  image: { Icon: ImageIcon, color: "#8b5cf6" },
  document: { Icon: DescriptionIcon, color: "#2563eb" },
  code: { Icon: CodeIcon, color: "#059669" },
  video: { Icon: VideoFileIcon, color: "#dc2626" },
  audio: { Icon: AudioFileIcon, color: "#d97706" },
  archive: { Icon: FolderZipIcon, color: "#64748b" },
  text: { Icon: TextSnippetIcon, color: "#0891b2" },
  other: { Icon: InsertDriveFileIcon, color: "#94a3b8" },
};

export default function FileTypeIcon({ fileName, size = "small", sx }) {
  const category = getFileCategory(fileName);
  const { Icon, color } = CATEGORY_CONFIG[category] || CATEGORY_CONFIG.other;
  return <Icon fontSize={size} sx={{ color, ...sx }} />;
}
